import React, { FC } from 'react';
import Styled from './styles';

const Summary: FC<any> = ({ data }) => {
	return (
		<Styled.Wrapper>
			<Styled.Count type="bold">{data}</Styled.Count>
		</Styled.Wrapper>
	);
};

export default React.memo(Summary);
